import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import { Loading } from "../sharedComponents";

// Lazy loading ile sayfa import'ları
const Login = lazy(() => import("../pages/Authentication/Login"));
const Register = lazy(() =>
  import("../pages/Authentication/Register/Register")
);
const ResetPassword = lazy(() =>
  import("../pages/Authentication/ResetPassword/ResetPassword")
);

export const publicRoutes = [
  {
    path: "/giris",
    component: (
      <Suspense fallback={<Loading />}>
        <Login />
      </Suspense>
    ),
    claim: "",
  },
  {
    path: "/kayit",
    component: (
      <Suspense fallback={<Loading />}>
        <Register />
      </Suspense>
    ),
    claim: "",
  },
  {
    path: "/sifremiunuttum",
    component: (
      <Suspense fallback={<Loading />}>
        <ResetPassword />
      </Suspense>
    ),
    claim: "",
  },
  {
    path: "*",
    component: <Navigate to={"/"} />,
    claim: "",
  },
];
